import { get } from 'svelte/store';
import config from '../config';
import { auth_client, dev } from "./store";
import sync from './sync';

import createAuth0Client from "@auth0/auth0-spa-js";

async function handle_redirect(client){
  if (client) {
    await client.handleRedirectCallback();
  }
  window.history.replaceState({}, document.title, '/');
  // if (client) {
  //   if (await client.isAuthenticated()) {
  //     const user = await client.getUser();
  //     if (!user.email_verified) {
  //       alert('Please verify your email before logging in');
  //       await logout({returnTo: window.location.href});
  //     }
  //   }
  // }
  // await sync.update_auth(client);
}
async function handle_unverified_email(client){
  window.history.replaceState({}, document.title, '/');
  alert('Please verify your email before logging in');
  await logout({returnTo: window.location.href});
}
async function init() {
  let redirect_uri = config.auth.redirect_uri;
  if (dev) {
    redirect_uri = 'http://localhost:5000';
  }
  let client = await createAuth0Client({
    issuer: 'https://' + config.auth.domain + '/',
    cacheLocation: 'localstorage',
    client_id: config.auth.client_id,
    domain: config.auth.domain,
    redirect_uri: redirect_uri,
    useCookiesForTransactions: true,
    useRefreshTokens: true
  });
  // if (dev) {console.log(`auth.init.client: ${client}`);}
  auth_client.set(client);
  const query = window.location.search;
  if (query.includes('code=') && query.includes('state=')) {
    await handle_redirect(client);
  }
  if (query.includes('error=unauthorized') && query.includes('error_description=Please%20verify%20your%20email%20before%20logging%20in')) {
    await handle_unverified_email(client);
  }
  await sync.update_auth(client);
}
async function login(options) {
  const client = get(auth_client);
  if (client) {
    await client.loginWithRedirect(options);
  }
}
async function logout(options) {
  const client = get(auth_client);
  if (client) {
    client.logout(options);
  }
  await sync.update_auth(client);
}

const auth = {
  handle_redirect,
  handle_unverified_email,
  init,
  login,
  logout,
};

export default auth;
